import { useState } from "react";

export function useModal(initialState = false) {
  const [isOpenModal, setisOpenModal] = useState<boolean>(initialState);

  const modalHandler = (state?: boolean) => {
    if (state) {
      setisOpenModal(state);
    } else {
      setisOpenModal((prev) => !prev);
    }
  };
  return { isOpenModal, modalHandler };
}
